import React from "react";
import i18n from "../../i18n";
import FileChooseButton from "../../components/FileChooseButton";
import uploadHandler from "../../utils/upload.handler";
import processingManager from "../../photolab/ProcessingManager";
import {apiResponseErrorCodes} from "../../utils/api";
import Creative from "../../photolab/Creative";
import CreativeView from "./CreativeView";
import {getCreativesConfigs} from "../../photolab/config";
import {defaultHandlerCatch} from "../../photolab/handlers/helpers";
import {logEvent, userEvents} from "../../utils/log";
import Processing from "../../photolab/Processing";
import UploadSelfieMessageModal from "../../components/UploadSelfieMessageModal";
import AppContext from "../../contexts/AppContext";
import {webviewAnalyticsEvent} from "../../utils/webview";
import {creativeName} from "../../utils/creative";

export default class CreativeAttachFileView extends React.Component {

  handleFileSelected = (file) => {
    const processing = processingManager.processing;
    const creative = this.props.creative;

    logEvent(userEvents.PHOTO_SELECT, {page: "result"});

    webviewAnalyticsEvent("photo_selected",
      processing.getExtra(Processing.EXTRA_TEXT),
      processing.getExtra(Creative.EXTRA_AI_SEED),
      "reaction",
      processing.getExtra(Creative.EXTRA_TEXT_APPEND),
      "template",
      creative.group + "/" + creativeName(creative)
    );

    creative.setExtra(Creative.EXTRA_ATTACH_FILE, "processing");
    creative.markAsPending();

    processingManager.update();

    uploadHandler(file)
      .then((result) => {
        logEvent(userEvents.PHOTO_UPLOADED, {
          file_id: result.id,
          file_url: result.url,
          uploaded_at: Date.now(),
        });

        const config = getCreativesConfigs().find((config) => config.templateId === creative.templateId);

        const newCreative = new Creative()
          .configureByConfig(config)
          .setExtra(Creative.EXTRA_ATTACH_FILE, null)
          .setAsSelected(true);

        processing.setExtra(Processing.EXTRA_SELFIE_MESSAGE_FILE, result);
        processing.replaceCreative(creative, newCreative);

        processingManager.update();
      })
      .catch(defaultHandlerCatch(creative, () => {
        processingManager.update();
      }));
  }

  showUploadSelfieModal = (creative) => {
    this.context.pushModal(<UploadSelfieMessageModal
      key="ResultPage_UploadSelfieMessageModal"
      onSelfieMessageFileSelected={this.handleFileSelected}
      onChatAvatarFileSelected={(file) => this.props.onFileSelected(file, false, "template")}
    />);
  }

  render() {
    const creative = this.props.creative;
    const processing = processingManager.processing;

    const creativeWaitingFile = (creative && creative.hasExtra(Creative.EXTRA_ATTACH_FILE))
      && !processing.getExtra(Processing.EXTRA_SELFIE_MESSAGE_FILE);
    const creativeIsPending = creative && creative.isPending && !creativeWaitingFile;
    const creativeIsProcessed = creative && creative.isProcessed;
    const creativeIsFailed = creative && creative.isFailed;

    if (creativeIsProcessed || creativeIsPending) {
      return <CreativeView
        showUploadSelfieModal={() => this.showUploadSelfieModal(creative)}
        {...this.props} />
    }

    return <React.Fragment>
      <div className="creative-holder">
        {creativeWaitingFile && <UploadView onFileSelected={this.handleFileSelected} />}
        {creativeIsFailed && <CreativeErrorView onFileSelected={this.handleFileSelected} {...this.props} />}
      </div>
    </React.Fragment>;
  }
}

CreativeAttachFileView.contextType = AppContext;

function UploadView(props) {
  return <div className="creative-view">
    <svg viewBox="0 0 92 138" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M70.941 50.251c3.386-.348 5.722 1.123 6.14 3.369.609 3.29-2.596 5.704-4.91 7.467l-1.23.887V50.251zm-27.379-6.457a8.132 8.132 0 0 1 4.499 1.364 8.071 8.071 0 0 1 2.98 3.621 8.025 8.025 0 0 1 .456 4.658 8.05 8.05 0 0 1-2.22 4.125 8.115 8.115 0 0 1-4.15 2.203 8.14 8.14 0 0 1-4.68-.46 8.094 8.094 0 0 1-3.634-2.97 8.034 8.034 0 0 1 1.012-10.183 8.14 8.14 0 0 1 5.737-2.358zm-5.1 17.293c-1.881.205-3.67.92-5.17 2.066a16.283 16.283 0 0 0-4.514 5.806 19.156 19.156 0 0 0-1.85 7.68c-.34 2.348-.554 6.368-.621 8.681h6.997l.564-8.983a9.917 9.917 0 0 1 .745-3.571 6.1 6.1 0 0 1 .937-1.55l.304 14.126h15.383l.18-11.97v.28-2.402c.388.467.703.99.937 1.55a9.92 9.92 0 0 1 .801 3.559l.564 8.983h6.997c-.067-2.313-.282-6.333-.62-8.68a19.17 19.17 0 0 0-1.862-7.68c-2.258-4.773-5.203-7.3-9.66-7.861-2.743-.225-7.36 0-10.158 0l.045-.034zm14.783-40.156L47.851 5.704l15.8 6.951L74.846 0 76.2 16.574 92 20.078l-12.662 9.994 4.615 15.72-13.7-6.265 1.241-2.718 7.73 3.527-3.385-11.353 9.344-7.355L73.356 19 72.42 7.254l-8.002 8.984-11.376-5.009 3.081 8.748-2.832.977-.046-.023zm6.93 5.132c.475 0 .94.14 1.335.403a2.38 2.38 0 0 1 .364 3.68 2.407 2.407 0 0 1-2.62.519 2.4 2.4 0 0 1-1.078-.881 2.383 2.383 0 0 1 .299-3.02 2.404 2.404 0 0 1 1.7-.7zm-43.71 8.748c5.485-.259 6.93 5.457 6.445 10.005-.282 2.673-.993 3.66-2.178 6.019-1.389 2.246-3.442 4.402-4.73 6.681v49.959c.003 1.492.303 2.968.884 4.342a11.227 11.227 0 0 0 2.503 3.665 11.503 11.503 0 0 0 3.498 2.425l.147.056a14.59 14.59 0 0 0 4.966.865h29.455c-5.756 5.379-11.952 8.983-18.983 9.208l-7.301 8.826c-1.569 1.438-3.386 1.595-5.587 0L4.413 122.758C2.257 121.276 0 119.827 0 116.784c0-2.111 1.253-4.211 3.149-6.299a13.116 13.116 0 0 0 1.918-6.738c.113-4.828-2.257-8.983-2.595-14.34-.286-7.653.038-15.316.97-22.918l.44-12.285c.1-1.094.46-2.149 1.05-3.077L15.8 34.923c.215-.046.434-.076.654-.09l.012-.022zm53.788 39.897v-3.245a11.466 11.466 0 0 1 7.516 3.616c2.776 3.369.982 8.197-2.11 10.51a4.64 4.64 0 0 1-2.156.854h.282c2.957 2.482 4.401 5.255 3.837 7.939-.812 3.964-7.189 8.051-11.014 8.332a4.371 4.371 0 0 1-2.423-.412 4.34 4.34 0 0 1-1.81-1.654c-2.178-3.369 1.129-6.962 3.386-9.197a15.128 15.128 0 0 1 4.435-3.066v-2.47a4.674 4.674 0 0 1-1.823-1.214 4.643 4.643 0 0 1-1.066-1.908c-.654-2.975 1.264-5.85 2.946-8.13v.045zm-.282 29.084.26-1.303c3.08-.235 5.349.798 6.51 3.594.498 2.762.215 5.615-2.403 7.187-2.404 1.504-7.64 2.436-10.157.752-2.517-1.684-2.359-4.829-.316-6.996a11.403 11.403 0 0 1 6.106-3.234zM27.999 23.233h31.6a8.983 8.983 0 0 1 6.325 2.612 8.894 8.894 0 0 1 2.625 6.293v39.01c-.006.105-.006.21 0 .315v2.65a19.97 19.97 0 0 0-2.258 3.66 10.152 10.152 0 0 0-.733 2.247V32.857h-43.81v1.954a5.647 5.647 0 0 0-2.698-1.685v-.977c0-1.169.232-2.326.681-3.406a8.89 8.89 0 0 1 1.941-2.886 8.976 8.976 0 0 1 6.328-2.6v-.024zm15.8 83.569a3.673 3.673 0 0 1 3.138 1.778 3.648 3.648 0 0 1-1.165 4.961 3.699 3.699 0 0 1-3.605.211 3.683 3.683 0 0 1-1.415-1.212 3.717 3.717 0 0 1-.643-2.078 3.645 3.645 0 0 1 1.081-2.592 3.677 3.677 0 0 1 2.61-1.068zm21.736-23.705v.1c.225.99.713 1.9 1.411 2.64a6.62 6.62 0 0 0 1.433 1.122v.304c-.532.285-1.049.6-1.546.943-.451.314-.891.651-1.32 1.01v-6.12h.022zm-1.986 20.92c.231.101.469.187.711.258-.64.454-1.233.969-1.772 1.538a9.66 9.66 0 0 0-.914 1.123 6.715 6.715 0 0 0-1.185 3.919 5.484 5.484 0 0 0 1.794 3.908c.29.267.599.511.926.73l.135.09a9.075 9.075 0 0 1-3.701.786H28a8.986 8.986 0 0 1-3.427-.675 8.945 8.945 0 0 1-2.905-1.93 8.886 8.886 0 0 1-2.618-6.3V57.269l.136-.236 2.561-4.491v51.475H63.55z" fill="#B7FFCF"/>
    </svg>
    <h3 dangerouslySetInnerHTML={{__html: i18n.t("result__creative_art_selfie")}}/>
    <p dangerouslySetInnerHTML={{__html: i18n.t("result__creative_make_emotional_selfie")}}/>

    <FileChooseButton
      onFileSelected={props.onFileSelected}
      children={i18n.t("btn_choose_photo")}/>
  </div>;
}

function CreativeErrorView(props) {
  const error = props.creative.error;
  const isPhotolabError = error.type === "photolab";
  const isPhotolabSystemError = isPhotolabError && error.code > -1000;

  const isNetworkError = (error.type === "network")
    || (error.message === "Network Error")
    || (error.name === "NetworkError")
    || (navigator.onLine === false);

  let message = "";
  if (isNetworkError) {
    message = i18n.t("error__network_message");
  }
  else if (error.type === "api"
    && error.code === apiResponseErrorCodes.FILE_FORMAT_INVALID)
  {
    message = i18n.t("error__api_code_415");
  } else if (isPhotolabSystemError) {
    message = i18n.t("error_overload");
  } else if (isPhotolabError) {
    message = error.message;
  } else {
    message = i18n.t("result__creative_failed_message");
  }

  return <div className="error-container">
    <div className="creative-error-message-container">
      <div className="creative-error-message">
        <p>{message}</p>

        <FileChooseButton
          onFileSelected={props.onFileSelected}
          children={i18n.t("btn_choose_photo")}/>
      </div>
    </div>
  </div>;
}